var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-refresh"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    clipPath: "url(#clip-refresh)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21252",
    "data-name": "Group 21252",
    transform: "translate(-50.277 -309.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Expanded",
    transform: "translate(52.134 313.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21200",
    "data-name": "Path 21200",
    d: "M54.729,321.76a.352.352,0,0,1-.257-.124l-2.237-2.571a.343.343,0,0,1,0-.486.333.333,0,0,1,.476,0l1.9,2.228,1.6-2.485a.352.352,0,0,1,.476-.1.333.333,0,0,1,.1.466l-1.847,2.856a.333.333,0,0,1-.267.162Z",
    transform: "translate(-52.134 -313.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21200_-_Outline",
    "data-name": "Path 21200 - Outline",
    d: "M54.714,322.259a.854.854,0,0,1-.619-.3l-.263-.3-.333-.383L51.867,319.4a.849.849,0,0,1-.233-.581.837.837,0,0,1,1.434-.593l.023.025,1.467,1.717,1.247-1.937a.852.852,0,0,1,1.152-.23l0,0a.833.833,0,0,1,.242,1.161L55.438,321.7Z",
    transform: "translate(-52.134 -313.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21201",
    "data-name": "Path 21201",
    d: "M68.617,322.641a.343.343,0,0,1-.286-.143l-1.647-2.456-1.9,2.266a.352.352,0,0,1-.486,0,.343.343,0,0,1,0-.486l2.19-2.618a.3.3,0,0,1,.276-.124.371.371,0,0,1,.267.152l1.9,2.856a.324.324,0,0,1-.086.466A.343.343,0,0,1,68.617,322.641Z",
    transform: "translate(-52.712 -313.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21201_-_Outline",
    "data-name": "Path 21201 - Outline",
    d: "M68.61,323.141a.845.845,0,0,1-.685-.351l-.009-.013-1.277-1.9-1.494,1.778-.02.019a.852.852,0,0,1-1.175,0l-.008-.008a.843.843,0,0,1-.019-1.174l2.17-2.6a.807.807,0,0,1,.638-.314c.026,0,.053,0,.079,0a.87.87,0,0,1,.623.357l.011.015,1.9,2.848a.824.824,0,0,1-.195,1.152.842.842,0,0,1-.528.186H68.61Z",
    transform: "translate(-52.712 -313.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21202",
    "data-name": "Path 21202",
    d: "M60.548,326.271a6.122,6.122,0,0,1-4.3-1.771.343.343,0,1,1,.486-.486,5.465,5.465,0,0,0,9.264-4.5.324.324,0,0,1,.3-.371.333.333,0,0,1,.381.3,6.17,6.17,0,0,1-6.122,6.836Z",
    transform: "translate(-52.326 -313.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21202_-_Outline",
    "data-name": "Path 21202 - Outline",
    d: "M60.548,326.771a6.583,6.583,0,0,1-4.655-1.915.843.843,0,1,1,1.191-1.195,4.965,4.965,0,0,0,8.414-4.087.824.824,0,0,1,.735-.931.833.833,0,0,1,.935.74,6.67,6.67,0,0,1-6.618,7.388Z",
    transform: "translate(-52.326 -313.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21203",
    "data-name": "Path 21203",
    d: "M54.835,321.546a.343.343,0,0,1-.333-.267A6.143,6.143,0,0,1,65.079,315.8a.344.344,0,0,1-.514.457,5.455,5.455,0,0,0-9.4,4.865.362.362,0,0,1-.257.419Z",
    transform: "translate(-52.24 -313.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21203_-_Outline",
    "data-name": "Path 21203 - Outline",
    d: "M54.865,322.047h-.032a.839.839,0,0,1-.819-.655,6.643,6.643,0,0,1,11.44-5.927.844.844,0,0,1-1.262,1.121A4.955,4.955,0,0,0,55.655,321l0,.017a.866.866,0,0,1-.612,1l-.036.01Z",
    transform: "translate(-52.24 -313.725)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshWhite);
export default __webpack_public_path__ + "static/media/refresh_white.c9cb7b58da44d843218c2d2916c2d9bb.svg";
export { ForwardRef as ReactComponent };